import { render, staticRenderFns } from "./DoublePrefixTitle.vue?vue&type=template&id=f3bf258a"
import script from "./DoublePrefixTitle.vue?vue&type=script&lang=js"
export * from "./DoublePrefixTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports